import PageHeader from '../layout/PageHeader'
import { Search } from '@mui/icons-material'
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Grid,
  Tabs,
  Tab,
} from '@mui/material'
import { useParams } from 'react-router'
import { faUserMd } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import makeStyles from '@mui/styles/makeStyles'
import PageContainer from '../layout/PageContainer'
import React, { useState, useEffect } from 'react'
import DoctorPatientsListPreview from './DoctorPatientsListPreview'
import axios from 'axios'
import DoctorExaminationsPreview from './DoctorExaminationsPreview'
import { Link, useRouteMatch, useHistory } from 'react-router-dom'

const useStyles = makeStyles((theme) => ({
  fontAwesome: {
    position: 'absolute',
    fontSize: '16rem',
    right: '20%',
    margin: 'auto 0',
    top: '50%',
    transform: 'translateY(-50%);',
    height: '80%',
    color: theme.palette.primary.light,
    overflow: 'hidden',
    opacity: '0.5',
  },
  customCard: {
    position: 'relative',
  },
  custom: {
    width: '100%',
    maxWidth: '50% !important',
  },
  // bookmark: {
  //   background: theme.palette.primary.light,
  //   width: '50%',
  //   height: '50px',
  //   borderRadius: '16px',
  //   marginBottom: '-8px',
  //   borderBottomLeftRadius: '0px',
  //   borderBottomRightRadius: '0px',
  // },
  // navTabs: {
  //   display: 'flex',
  //   background: theme.palette.primary.light,
  //   boxShadow:
  //     '0px 0px 0px 0px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)',
  // },
  // test: {
  //   background: '#fff',
  //   boxShadow:
  //     '0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)',
  // },
}))

const tabNameToIndex = {
  0: 'examinations',
  1: 'patients',
}

const indexToTabName = {
  examinations: 0,
  patients: 1,
}

function LinkTab(props) {
  return <Tab component={Link} {...props} />
}

const DoctorsPreview = () => {
  const { id } = useParams()
  const match = useRouteMatch()
  const history = useHistory()
  const [doctor, setDoctor] = useState()
  const [tab, setTab] = useState(indexToTabName[match.params.page])

  useEffect(() => {
    if (id) {
      loadDoctor(id)
    }
  }, [id])

  const loadDoctor = (id) => {
    axios.post(`/doctors/${id}`).then((res) => {
      if (res.status == 200) {
        setDoctor(res.data)
      }
    })
  }

  const classes = useStyles()

  const handleTabChange = (event, newValue) => {
    history.push(`${tabNameToIndex[newValue]}`)
    setTab(newValue)
  }

  return (
    <>
      <PageHeader
        icon={<Search fontSize="large" />}
        title="Podgląd lekarza"
        subtitle="Tutaj znajdziesz szczegóły na temat konkretnego lekarza"
      />
      <PageContainer>
        {doctor && (
          <Card className={classes.customCard} elevation={2} square>
            <FontAwesomeIcon className={classes.fontAwesome} icon={faUserMd} />
            <CardHeader
              title={`${doctor.firstname} ${doctor.lastname}`}
            ></CardHeader>
            <CardContent>
              <div>
                <Card
                  elevation={0}
                  className="flex flex-col pt-0 text-black lg:w-full md:w-full p-4 whitespace-nowrap"
                >
                  <Typography variant="subtitle1">
                    E-mail: {doctor.email}
                  </Typography>
                  <Typography variant="subtitle1">
                    Nr. tel.: {doctor.phone_number}
                  </Typography>
                </Card>
              </div>
            </CardContent>
          </Card>
        )}
        <Grid item xs={12}>
          <Card>
            <Tabs value={tab} onChange={handleTabChange} aria-label="nav tabs">
              <LinkTab
                label="Lista badań"
                to="examinations"
                className={classes.custom}
              />
              <LinkTab
                label="Lista pacjentów"
                to="patients"
                className={classes.custom}
              />
            </Tabs>
            <CardContent className="no-padding">
              {tab === 0 && <DoctorExaminationsPreview doctorId={Number(id)} />}
              {tab === 1 && <DoctorPatientsListPreview doctorId={Number(id)} />}
            </CardContent>
          </Card>
        </Grid>
      </PageContainer>
    </>
  )
}

export default DoctorsPreview
